import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import pt from 'vuetify/es5/locale/pt'
import colors from 'vuetify/lib/util/colors'

Vue.use(Vuetify)

export default new Vuetify({
	icons: {
		iconfont: 'mdi',
	},
	lang: {
		current: 'pt',
		locales: { pt },
	},
	theme: {
		options: {
			customProperties: true,
		},
		themes: {
			light: {
				primary: '#0067a5',
				secondary: '#0067a5',
				principal: '#F0F1F3',
				...colors,
			},
		},
	},
})
